import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
dayjs.locale('th');

export class ProgramCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            airlineList: [],
            countryList: [],
            data: {
                code: '', name: '', caption: '', place: '',
                days: 1, night: 0, month: '', airline: 0,
                startPrice: '', country: '', condition: '',
                contId: 0, provId: 0,
                totalMeal: '', totalHotelRate: 0, totalFlightRate: 0,
                totalPlace: 0, totalActivity: 0, totalShopping: 0, totalFreedays: 0
            },
            coverFile: null, coverPreview: '',
            pdfFile: null, pdfName: '',
            highlights: [{ text: '', icon: 'fas fa-check' }],
            periods: [{ start: '', end: '', adultPrice: '', childPrice: '', childNoBed: '', singleBed: '', adultNoTicket: '', childNoTicket: '', childNoBedNoTicket: '', singleBedNoTicket: '', limit: 0, desc: '' }],
            itinerary: [{ day: 1, places: '', breakfast: 0, lunch: 0, dinner: 0, hotel: '', detail: '' }],
            includes: [{ name: '', included: 1 }],
            saving: false,
            savedId: null
        };
        this.coverInput = React.createRef();
        this.pdfInput = React.createRef();
    }

    componentDidMount() {
        this.loadAirlines();
        this.loadCountries();
    }

    loadAirlines() {
        fetch('api/GetAirlinelist')
            .then(r => r.ok ? r.json() : [])
            .then(json => this.setState({ airlineList: json }))
            .catch(() => {});
    }

    loadCountries() {
        fetch('api/GetCountrylist')
            .then(r => r.ok ? r.json() : [])
            .then(json => this.setState({ countryList: json }))
            .catch(() => {});
    }

    updateData(field, value) {
        var data = { ...this.state.data };
        data[field] = value;
        if (field === 'days') {
            var itinerary = [...this.state.itinerary];
            var days = parseInt(value) || 1;
            while (itinerary.length < days) {
                itinerary.push({ day: itinerary.length + 1, places: '', breakfast: 0, lunch: 0, dinner: 0, hotel: '', detail: '' });
            }
            while (itinerary.length > days) itinerary.pop();
            this.setState({ data, itinerary });
        } else {
            this.setState({ data });
        }
    }

    updateItinerary(index, field, value) {
        var itinerary = [...this.state.itinerary];
        itinerary[index][field] = value;
        this.setState({ itinerary });
    }

    updatePeriod(index, field, value) {
        var periods = [...this.state.periods];
        periods[index][field] = value;
        this.setState({ periods });
    }

    addPeriod() {
        var periods = [...this.state.periods];
        periods.push({ start: '', end: '', adultPrice: '', childPrice: '', childNoBed: '', singleBed: '', adultNoTicket: '', childNoTicket: '', childNoBedNoTicket: '', singleBedNoTicket: '', limit: 0, desc: '' });
        this.setState({ periods });
    }

    removePeriod(index) {
        var periods = [...this.state.periods];
        periods.splice(index, 1);
        this.setState({ periods });
    }

    addHighlight() {
        var highlights = [...this.state.highlights];
        highlights.push({ text: '', icon: 'fas fa-check' });
        this.setState({ highlights });
    }

    removeHighlight(index) {
        var highlights = [...this.state.highlights];
        highlights.splice(index, 1);
        this.setState({ highlights });
    }

    updateHighlight(index, value) {
        var highlights = [...this.state.highlights];
        highlights[index].text = value;
        this.setState({ highlights });
    }

    addInclude(included) {
        var includes = [...this.state.includes];
        includes.push({ name: '', included });
        this.setState({ includes });
    }

    removeInclude(index) {
        var includes = [...this.state.includes];
        includes.splice(index, 1);
        this.setState({ includes });
    }

    updateInclude(index, value) {
        var includes = [...this.state.includes];
        includes[index].name = value;
        this.setState({ includes });
    }

    onCoverSelect(e) {
        if (e.target.files && e.target.files[0]) {
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ coverFile: file, coverPreview: reader.result });
            };
            reader.readAsDataURL(file);
        }
    }

    onPdfSelect(e) {
        if (e.target.files && e.target.files[0]) {
            this.setState({ pdfFile: e.target.files[0], pdfName: e.target.files[0].name });
        }
    }

    async handleSave() {
        const { data, periods, itinerary, highlights, includes, coverFile, pdfFile } = this.state;

        if (!data.code || !data.name) {
            alert('กรุณากรอกรหัสทัวร์และชื่อโปรแกรม');
            return;
        }

        this.setState({ saving: true });

        try {
            // Save main program
            var body = {
                data: {
                    proG_ID: 0, proG_CODE: data.code, proG_NAME: data.name,
                    proG_CAPTION: data.caption, proG_PLACE: data.place,
                    proG_DAYS: parseInt(data.days), proG_NIGHT: parseInt(data.night),
                    proG_MONTH: data.month, airL_ID: parseInt(data.airline),
                    proG_START_PRICE: data.startPrice, proG_COUNTRY: data.country,
                    proG_CONDITION: data.condition, proG_CONT_ID: parseInt(data.contId),
                    proG_PROV_ID: parseInt(data.provId),
                    proG_TOTAL_MEAL: data.totalMeal,
                    proG_TOTAL_HOTEL_RATE: parseInt(data.totalHotelRate),
                    proG_TOTAL_FLIGHT_RATE: parseInt(data.totalFlightRate),
                    proG_TOTAL_PLACE: parseInt(data.totalPlace),
                    proG_TOTAL_ACTIVITY: parseInt(data.totalActivity),
                    proG_TOTAL_SHOPPING: parseInt(data.totalShopping),
                    proG_TOTAL_FREEDAYS: parseInt(data.totalFreedays)
                },
                prices: periods.map(p => ({
                    id: 0, start: p.start, end: p.end,
                    adult_price: p.adultPrice, children_price: p.childPrice,
                    children_not_bed: p.childNoBed, single_bedded: p.singleBed,
                    adult_price_noticket: p.adultNoTicket, children_price_noticket: p.childNoTicket,
                    children_not_bed_noticket: p.childNoBedNoTicket, single_bedded_noticket: p.singleBedNoTicket,
                    limit: p.limit, description: p.desc, isupdate: 1
                })),
                timesdetail: itinerary.map((it, i) => ({
                    day: i + 1, places: it.places,
                    breakfast: it.breakfast, lunch: it.lunch, dinner: it.dinner,
                    detail: it.detail, hotel_desc: it.hotel
                })),
                highlights: highlights.filter(h => h.text).map((h, i) => ({
                    name: h.text, icon: h.icon, index: i, included: 1
                })),
                includes: includes.filter(inc => inc.name).map((inc, i) => ({
                    name: inc.name, included: inc.included, index: i
                }))
            };

            var res = await fetch('api/ProgramManage', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });

            if (!res.ok) throw new Error('Save failed');
            var result = await res.json();
            var progId = result.desc;

            // Upload cover image
            if (coverFile) {
                var coverForm = new FormData();
                coverForm.append("image", coverFile);
                coverForm.append("id", progId);
                coverForm.append("oldpath", "");
                await fetch('upload/Programcoverimage', { method: 'POST', body: coverForm });
            }

            // Upload PDF
            if (pdfFile) {
                var pdfForm = new FormData();
                pdfForm.append("image", pdfFile);
                pdfForm.append("id", progId);
                pdfForm.append("oldpath", "");
                await fetch('upload/ProgramPDFfile', { method: 'POST', body: pdfForm });
            }

            this.setState({ saving: false, savedId: progId });
            alert('บันทึกสำเร็จ! รหัสโปรแกรม: ' + progId);
            window.location.href = '/console/programmanagement';

        } catch (err) {
            this.setState({ saving: false });
            alert('เกิดข้อผิดพลาด: ' + err.message);
        }
    }

    renderStepIndicator() {
        const steps = ['ข้อมูลทั่วไป', 'ช่วงเดินทาง & ราคา', 'โปรแกรมรายวัน', 'เงื่อนไข & สรุป'];
        return (
            <div className="d-flex justify-content-center mb-4">
                {steps.map((s, i) => (
                    <div key={i} className="d-flex align-items-center">
                        <div onClick={() => this.setState({ step: i + 1 })}
                            style={{
                                width: 36, height: 36, borderRadius: '50%',
                                background: this.state.step >= i + 1 ? '#dc3545' : '#dee2e6',
                                color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 'bold', cursor: 'pointer', fontSize: 14
                            }}>
                            {i + 1}
                        </div>
                        <span style={{ margin: '0 8px', fontSize: 13, color: this.state.step >= i + 1 ? '#333' : '#999' }}>{s}</span>
                        {i < steps.length - 1 && <div style={{ width: 40, height: 2, background: this.state.step > i + 1 ? '#dc3545' : '#dee2e6', margin: '0 4px' }} />}
                    </div>
                ))}
            </div>
        );
    }

    // Step 1: General Info
    renderStep1() {
        const { data, airlineList, coverPreview, pdfName } = this.state;
        return (
            <div>
                <h5 className="mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: 8 }}>
                    <i className="fas fa-info-circle"></i> ข้อมูลทั่วไป
                </h5>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <label className="form-label fw-bold">รหัสทัวร์ *</label>
                        <input type="text" className="form-control" placeholder="เช่น AJ06_3"
                            value={data.code} onChange={e => this.updateData('code', e.target.value)} />
                    </div>
                    <div className="col-md-9 mb-3">
                        <label className="form-label fw-bold">ชื่อโปรแกรม *</label>
                        <input type="text" className="form-control" placeholder="เช่น HAPPINESS SPRINGTIME SAKURA IN KANSAI 6D3N"
                            value={data.name} onChange={e => this.updateData('name', e.target.value)} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-bold">คำบรรยาย / สถานที่เที่ยว</label>
                        <input type="text" className="form-control" placeholder="เช่น โอซาก้า อาราชิยาม่า เกียวโต โกเบ"
                            value={data.caption} onChange={e => this.updateData('caption', e.target.value)} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-2 mb-3">
                        <label className="form-label fw-bold">จำนวนวัน</label>
                        <input type="number" className="form-control" min="1"
                            value={data.days} onChange={e => this.updateData('days', e.target.value)} />
                    </div>
                    <div className="col-md-2 mb-3">
                        <label className="form-label fw-bold">จำนวนคืน</label>
                        <input type="number" className="form-control" min="0"
                            value={data.night} onChange={e => this.updateData('night', e.target.value)} />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label fw-bold">สายการบิน</label>
                        <select className="form-control" value={data.airline} onChange={e => this.updateData('airline', e.target.value)}>
                            <option value="0">-- เลือกสายการบิน --</option>
                            {airlineList.map(a => <option key={a.airL_ID} value={a.airL_ID}>{a.airL_NAME}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                        <label className="form-label fw-bold">เดือนเดินทาง</label>
                        <input type="text" className="form-control" placeholder="เช่น APR 2026"
                            value={data.month} onChange={e => this.updateData('month', e.target.value)} />
                    </div>
                    <div className="col-md-2 mb-3">
                        <label className="form-label fw-bold">ราคาเริ่มต้น</label>
                        <input type="text" className="form-control" placeholder="57,500"
                            value={data.startPrice} onChange={e => this.updateData('startPrice', e.target.value)} />
                    </div>
                </div>

                <h6 className="mt-4 mb-3" style={{ color: '#dc3545' }}>
                    <i className="fas fa-star"></i> จุดเด่น / ทำไมต้องไปกับเรา?
                </h6>
                {this.state.highlights.map((h, i) => (
                    <div key={i} className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                        <i className="fas fa-check-circle" style={{ color: '#dc3545' }}></i>
                        <input type="text" className="form-control form-control-sm" placeholder="เช่น สายการบินระดับชาติ"
                            value={h.text} onChange={e => this.updateHighlight(i, e.target.value)} />
                        <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeHighlight(i)}><i className="fas fa-times"></i></button>
                    </div>
                ))}
                <button className="btn btn-outline-secondary btn-sm" onClick={() => this.addHighlight()}>
                    <i className="fas fa-plus"></i> เพิ่มจุดเด่น
                </button>

                <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">ภาพปก</label>
                        <div>
                            <input type="file" accept="image/*" ref={this.coverInput} style={{ display: 'none' }}
                                onChange={e => this.onCoverSelect(e)} />
                            <button className="btn btn-outline-primary btn-sm" onClick={() => this.coverInput.current.click()}>
                                <i className="fas fa-image"></i> เลือกรูปภาพ
                            </button>
                            {coverPreview && <img src={coverPreview} alt="cover" style={{ maxHeight: 150, marginLeft: 12, borderRadius: 8 }} />}
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-bold">ไฟล์ PDF รายละเอียดทัวร์</label>
                        <div>
                            <input type="file" accept=".pdf" ref={this.pdfInput} style={{ display: 'none' }}
                                onChange={e => this.onPdfSelect(e)} />
                            <button className="btn btn-outline-primary btn-sm" onClick={() => this.pdfInput.current.click()}>
                                <i className="fas fa-file-pdf"></i> เลือกไฟล์ PDF
                            </button>
                            {pdfName && <span style={{ marginLeft: 12 }}><i className="fas fa-file-pdf" style={{ color: '#dc3545' }}></i> {pdfName}</span>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Step 2: Periods & Pricing
    renderStep2() {
        const { periods } = this.state;
        return (
            <div>
                <h5 className="mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: 8 }}>
                    <i className="fas fa-calendar-alt"></i> ช่วงเดินทางและราคา
                </h5>

                {periods.map((p, i) => (
                    <div key={i} className="card mb-3">
                        <div className="card-header d-flex justify-content-between align-items-center" style={{ background: '#f8f9fa' }}>
                            <strong>ช่วงที่ {i + 1}</strong>
                            {periods.length > 1 && <button className="btn btn-outline-danger btn-sm" onClick={() => this.removePeriod(i)}><i className="fas fa-trash"></i></button>}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3 mb-2">
                                    <label className="form-label">เริ่มเดินทาง</label>
                                    <DatePicker className="form-control" dateFormat="dd/MM/yyyy"
                                        selected={p.start ? new Date(p.start) : null}
                                        onChange={e => this.updatePeriod(i, 'start', dayjs(e).format('YYYY-MM-DD'))}
                                        peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label">สิ้นสุดเดินทาง</label>
                                    <DatePicker className="form-control" dateFormat="dd/MM/yyyy"
                                        selected={p.end ? new Date(p.end) : null}
                                        onChange={e => this.updatePeriod(i, 'end', dayjs(e).format('YYYY-MM-DD'))}
                                        peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label">จำนวนที่เปิด</label>
                                    <input type="number" className="form-control" value={p.limit} onChange={e => this.updatePeriod(i, 'limit', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label">หมายเหตุ</label>
                                    <input type="text" className="form-control" value={p.desc} onChange={e => this.updatePeriod(i, 'desc', e.target.value)} />
                                </div>
                            </div>

                            <h6 className="mt-3 mb-2">ราคารวมตั๋ว</h6>
                            <div className="row">
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>ผู้ใหญ่</label>
                                    <input type="text" className="form-control form-control-sm" value={p.adultPrice} onChange={e => this.updatePeriod(i, 'adultPrice', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>เด็ก (มีเตียง)</label>
                                    <input type="text" className="form-control form-control-sm" value={p.childPrice} onChange={e => this.updatePeriod(i, 'childPrice', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>เด็ก (ไม่มีเตียง)</label>
                                    <input type="text" className="form-control form-control-sm" value={p.childNoBed} onChange={e => this.updatePeriod(i, 'childNoBed', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>พักเดี่ยว เพิ่ม</label>
                                    <input type="text" className="form-control form-control-sm" value={p.singleBed} onChange={e => this.updatePeriod(i, 'singleBed', e.target.value)} />
                                </div>
                            </div>

                            <h6 className="mt-2 mb-2">ราคาไม่รวมตั๋ว</h6>
                            <div className="row">
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>ผู้ใหญ่</label>
                                    <input type="text" className="form-control form-control-sm" value={p.adultNoTicket} onChange={e => this.updatePeriod(i, 'adultNoTicket', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>เด็ก (มีเตียง)</label>
                                    <input type="text" className="form-control form-control-sm" value={p.childNoTicket} onChange={e => this.updatePeriod(i, 'childNoTicket', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>เด็ก (ไม่มีเตียง)</label>
                                    <input type="text" className="form-control form-control-sm" value={p.childNoBedNoTicket} onChange={e => this.updatePeriod(i, 'childNoBedNoTicket', e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-2">
                                    <label className="form-label" style={{ fontSize: 13 }}>พักเดี่ยว เพิ่ม</label>
                                    <input type="text" className="form-control form-control-sm" value={p.singleBedNoTicket} onChange={e => this.updatePeriod(i, 'singleBedNoTicket', e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <button className="btn btn-outline-secondary" onClick={() => this.addPeriod()}>
                    <i className="fas fa-plus"></i> เพิ่มช่วงเดินทาง
                </button>
            </div>
        );
    }

    // Step 3: Daily Itinerary
    renderStep3() {
        const { itinerary } = this.state;
        return (
            <div>
                <h5 className="mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: 8 }}>
                    <i className="fas fa-route"></i> โปรแกรมการเดินทางรายวัน
                </h5>

                {itinerary.map((day, i) => (
                    <div key={i} className="card mb-3">
                        <div className="card-header" style={{ background: i === 0 ? '#dc3545' : '#f8f9fa', color: i === 0 ? '#fff' : '#333' }}>
                            <strong>วันที่ {i + 1}</strong>
                        </div>
                        <div className="card-body">
                            <div className="row mb-2">
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">สถานที่ / หัวข้อ</label>
                                    <input type="text" className="form-control"
                                        placeholder="เช่น สนามบินโอซาก้า – อาราชิยาม่า - ป่าไผ่ – สะพานโทเก็ตสึเคียว"
                                        value={day.places} onChange={e => this.updateItinerary(i, 'places', e.target.value)} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label fw-bold">โรงแรม</label>
                                    <input type="text" className="form-control" placeholder="ชื่อโรงแรม หรือ -"
                                        value={day.hotel} onChange={e => this.updateItinerary(i, 'hotel', e.target.value)} />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-md-12">
                                    <label className="form-label">มื้ออาหาร</label>
                                    <div className="d-flex" style={{ gap: 20 }}>
                                        <label className="d-flex align-items-center" style={{ gap: 4 }}>
                                            <input type="checkbox" checked={day.breakfast === 1}
                                                onChange={e => this.updateItinerary(i, 'breakfast', e.target.checked ? 1 : 0)} />
                                            เช้า
                                        </label>
                                        <label className="d-flex align-items-center" style={{ gap: 4 }}>
                                            <input type="checkbox" checked={day.lunch === 1}
                                                onChange={e => this.updateItinerary(i, 'lunch', e.target.checked ? 1 : 0)} />
                                            กลางวัน
                                        </label>
                                        <label className="d-flex align-items-center" style={{ gap: 4 }}>
                                            <input type="checkbox" checked={day.dinner === 1}
                                                onChange={e => this.updateItinerary(i, 'dinner', e.target.checked ? 1 : 0)} />
                                            เย็น
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="form-label fw-bold">รายละเอียด</label>
                                <SunEditor
                                    setContents={day.detail}
                                    onChange={content => this.updateItinerary(i, 'detail', content)}
                                    setOptions={{
                                        height: 200,
                                        buttonList: [
                                            ['bold', 'italic', 'underline'],
                                            ['fontColor', 'hiliteColor'],
                                            ['list', 'align'],
                                            ['image', 'link'],
                                            ['removeFormat']
                                        ]
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // Step 4: Conditions & Summary
    renderStep4() {
        const { data, includes } = this.state;
        var incList = includes.filter(i => i.included === 1);
        var excList = includes.filter(i => i.included === 0);

        return (
            <div>
                <h5 className="mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: 8 }}>
                    <i className="fas fa-file-contract"></i> เงื่อนไขและข้อกำหนด
                </h5>

                <div className="row">
                    <div className="col-md-6 mb-4">
                        <h6 style={{ color: '#28a745' }}><i className="fas fa-check-circle"></i> อัตรานี้รวม</h6>
                        {incList.map((item, i) => {
                            var realIndex = includes.indexOf(item);
                            return (
                                <div key={realIndex} className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                                    <span style={{ color: '#28a745' }}><i className="fas fa-check"></i></span>
                                    <input type="text" className="form-control form-control-sm"
                                        placeholder="เช่น ค่าตั๋วเครื่องบินไป-กลับ"
                                        value={item.name} onChange={e => this.updateInclude(realIndex, e.target.value)} />
                                    <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeInclude(realIndex)}><i className="fas fa-times"></i></button>
                                </div>
                            );
                        })}
                        <button className="btn btn-outline-success btn-sm" onClick={() => this.addInclude(1)}>
                            <i className="fas fa-plus"></i> เพิ่มรายการ
                        </button>
                    </div>
                    <div className="col-md-6 mb-4">
                        <h6 style={{ color: '#dc3545' }}><i className="fas fa-times-circle"></i> อัตรานี้ไม่รวม</h6>
                        {excList.map((item, i) => {
                            var realIndex = includes.indexOf(item);
                            return (
                                <div key={realIndex} className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                                    <span style={{ color: '#dc3545' }}><i className="fas fa-times"></i></span>
                                    <input type="text" className="form-control form-control-sm"
                                        placeholder="เช่น ค่าทำหนังสือเดินทาง"
                                        value={item.name} onChange={e => this.updateInclude(realIndex, e.target.value)} />
                                    <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeInclude(realIndex)}><i className="fas fa-times"></i></button>
                                </div>
                            );
                        })}
                        <button className="btn btn-outline-danger btn-sm" onClick={() => this.addInclude(0)}>
                            <i className="fas fa-plus"></i> เพิ่มรายการ
                        </button>
                    </div>
                </div>

                <h6 className="mt-3 mb-2"><i className="fas fa-sticky-note"></i> เงื่อนไขการจอง / หมายเหตุ</h6>
                <SunEditor
                    setContents={data.condition}
                    onChange={content => this.updateData('condition', content)}
                    setOptions={{
                        height: 200,
                        buttonList: [['bold', 'italic', 'underline'], ['list'], ['removeFormat']]
                    }}
                />
            </div>
        );
    }

    render() {
        const { step, saving } = this.state;

        return (
            <div style={{ padding: '20px', maxWidth: 1100, margin: '0 auto' }}>
                <div className="d-flex justify-content-end align-items-center mb-4">
                    <a href="/console/programmanagement" className="btn btn-outline-secondary btn-sm">
                        <i className="fas fa-arrow-left"></i> กลับ
                    </a>
                </div>

                {this.renderStepIndicator()}

                <div className="card">
                    <div className="card-body" style={{ minHeight: 400 }}>
                        {step === 1 && this.renderStep1()}
                        {step === 2 && this.renderStep2()}
                        {step === 3 && this.renderStep3()}
                        {step === 4 && this.renderStep4()}
                    </div>
                    <div className="card-footer d-flex justify-content-between">
                        <button className="btn btn-secondary" disabled={step === 1}
                            onClick={() => this.setState({ step: step - 1 })}>
                            <i className="fas fa-chevron-left"></i> ย้อนกลับ
                        </button>
                        <div>
                            {step < 4 ? (
                                <button className="btn btn-primary"
                                    onClick={() => this.setState({ step: step + 1 })}>
                                    ถัดไป <i className="fas fa-chevron-right"></i>
                                </button>
                            ) : (
                                <button className="btn btn-danger" disabled={saving}
                                    onClick={() => this.handleSave()}>
                                    <i className="fas fa-save"></i> {saving ? 'กำลังบันทึก...' : 'บันทึกโปรแกรมทัวร์'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
